import axios from 'axios';
import EventEmitter from 'events';
const URL_Base = "https://digi-rooms-server.onrender.com"

const API = axios.create({
  baseURL: `${URL_Base}/api/`
});

//const API = axios.create({
//  baseURL: `http://localhost:5000/api/`
//});


export const NetworkEvents = new EventEmitter();
API.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      NetworkEvents.emit("Network_Error");
      return Promise.reject({ isNetworkError: true });
    } else {
      NetworkEvents.emit("Network_Online");
    }
    return Promise.reject(error);
  }
);

export default API;